export const REALDB_CONSTANT = {
  Sellersdata: "/tritiya_2026/Sellersdata",
  SellerBaseData: "/tritiya_2026/SellerBaseData",
};
